import {
  formattedDate,
  formattedDuration,
  formattedPredictionDateTime,
  formattedTime,
} from "../../components/formatted/FormattedDateAndTime";
import { MIN_HISTORY_DAYS_FOR_PREDICTION } from "../../constants/cache";
import {
  calculateHistoryDays,
  extractReliablePrediction,
} from "../../shared/utils/utils";

export const MONITORING_IMAGE_SIZE = 108;

export function formatMonitoringTakenLine({ time, t }) {
  const dayPart =
    formattedDate(time, t) === t("Today")
      ? t("Today").toLowerCase()
      : formattedDate(time, t, true);

  return `${t("Taken")} ${dayPart} ${t("at")} ${formattedTime(time)}`;
}

export function getMonitoringPredictionLabel(container, t) {
  return container?.limitFillingLevel
    ? `${container.limitFillingLevel}% ${t("reached at")}`
    : t("Filling time");
}

export function getMonitoringPredictionDisplay({
  container,
  fillingSpeed,
  t,
  currentDate = new Date(),
}) {
  const durationData = fillingSpeed?.durationFullFillingMs?.[0];

  if (container.filling_level === 100) {
    return {
      value: t("Maximum level reached"),
      muted: false,
      danger: false,
    };
  }

  if (durationData?.duration === -1) {
    return {
      value: t("Limit exceeded"),
      muted: false,
      danger: true,
    };
  }

  const reliablePredictionValue = extractReliablePrediction(fillingSpeed);
  const historyDays = calculateHistoryDays(fillingSpeed?.fromDate, currentDate);
  const hasEnoughHistory =
    historyDays !== null && historyDays >= MIN_HISTORY_DAYS_FOR_PREDICTION;
  const hasOpeningHours = Boolean(container?.addressJoin?.opening);

  if (reliablePredictionValue === true && hasOpeningHours) {
    if (!hasEnoughHistory) {
      return {
        value: t("Not enough history for prediction"),
        muted: true,
        danger: false,
      };
    }

    if (durationData?.predictionDatetime) {
      const timezone =
        durationData?.timezone ||
        container?.addressJoin?.timezone ||
        "Europe/Paris";
      const formatted = formattedPredictionDateTime(
        durationData.predictionDatetime,
        timezone,
        t,
      );
      if (formatted) {
        return { value: formatted, muted: false, danger: false };
      }
    }

    if (durationData?.duration && Number.isFinite(durationData.duration)) {
      return {
        value: formattedDuration(durationData.duration),
        muted: false,
        danger: false,
      };
    }
  }

  return { value: "...", muted: true, danger: false };
}
